import Vue from "vue";
import Router from "vue-router";
import Index from "@/components/Index";
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const Qxzq = resolve => require(["@/components/Qxzq"], resolve);

const Login = resolve => require(["@/components/Login"], resolve);
const SignUp = resolve => require(["@/components/SignUp"], resolve);
const ForgetPassword = resolve =>
  require(["@/components/ForgetPassword.vue"], resolve);
const CheckPhone = resolve =>
  require(["@/components/signUp/CheckPhone"], resolve);
const InputInfo = resolve =>
  require(["@/components/signUp/InputInfo"], resolve);
const SignUpDone = resolve =>
  require(["@/components/signUp/SignUpDone"], resolve);
const GoodsList = resolve => require(["@/components/GoodsList"], resolve);
const GoodsDetail = resolve => require(["@/components/GoodsDetail"], resolve);
const GoodsDetailPreview = resolve => require(["@/components/GoodsDetailPreview"], resolve);
const ShoppingCart = resolve => require(["@/components/ShoppingCart"], resolve);
const Order = resolve => require(["@/components/Order"], resolve);
const Pay = resolve => require(["@/components/Pay"], resolve);
const PayDone = resolve => require(["@/components/PayDone"], resolve);
const Freeback = resolve => require(["@/components/Freeback"], resolve);
const Home = resolve => require(["@/components/Home"], resolve);
const MyAddress = resolve => require(["@/components/home/MyAddress"], resolve);
const AddAddress = resolve =>
  require(["@/components/home/AddAddress"], resolve);
const MyOrder = resolve => require(["@/components/home/MyOrder"], resolve);
const MyShoppingCart = resolve =>
  require(["@/components/home/MyShoppingCart"], resolve);
const Merchant = resolve => require(["@/components/Merchant"], resolve);
const NoLogin = resolve => require(["@/components/popup/NoLogin"], resolve);
const IndexPopup = resolve =>
  require(["@/components/popup/IndexPopup"], resolve);
const Collect = resolve => require(["@/components/popup/Collect"], resolve);
const DeleteCart = resolve =>
  require(["@/components/popup/DeleteCart"], resolve);
const NoCollect = resolve => require(["@/components/popup/NoCollect"], resolve);
const ListClassify = resolve =>
  require(["@/components/nav/ListClassify"], resolve);
const RightFlex = resolve => require(["@/components/nav/RightFlex"], resolve);
const BackTop = resolve => require(["@/components/nav/BackTop"], resolve);
const ShopCart = resolve => require(["@/components/cart/ShopCart"], resolve);
const MyCart = resolve => require(["@/components/cart/MyCart"], resolve);
const CheckOder = resolve => require(["@/components/cart/CheckOder"], resolve);
const PayOder = resolve => require(["@/components/cart/PayOder"], resolve);
const CompletePay = resolve =>
  require(["@/components/cart/CompletePay"], resolve);
const ChineseMedicineZone = resolve =>
  // require(["@/components/specialZone/ChineseMedicineZone"], resolve);
  require(["@/components/Qxzq"], resolve);
const ClinicZone = resolve =>
  require(["@/components/specialZone/ClinicZone"], resolve);
const BrandZone = resolve =>
  require(["@/components/specialZone/BrandZone"], resolve);
const PublicZone = resolve =>
  require(["@/components/specialZone/PublicZone"], resolve);
const NewDrug = resolve =>
  require(["@/components/specialZone/NewDrug"], resolve);
const NewCoupons = resolve =>
  require(["@/components/specialZone/NewCoupons"], resolve);
const NewSpecialOffer = resolve =>
  require(["@/components/specialZone/NewSpecialOffer"], resolve);
const EmptyPage = resolve =>
  require(["@/components/public/EmptyPage"], resolve);
const ApparatusZone = resolve =>
  require(["@/components/specialZone/ApparatusZone"], resolve);
const DailyZone = resolve =>
  require(["@/components/specialZone/DailyZone"], resolve);
const ClearZoom = resolve =>
  require(["@/components/specialZone/ClearZoom"], resolve)
const SigMail = resolve =>
  require(["@/components/specialZone/sigMail"], resolve);
const NewGoods = resolve =>
  require(["@/components/specialZone/newGoods"], resolve);
const BrandList = resolve =>
  require(["@/components/specialZone/BrandList"], resolve);
const ComPackageZone = resolve =>
  require(["@/components/specialZone/ComPackageZone"], resolve);
const FreeZone = resolve =>
  require(["@/components/specialZone/FreeZone"], resolve);
const SpecialZone = resolve =>
  require(["@/components/specialZone/SpecialZone"], resolve);
const YzxZone = resolve =>
  require(["@/components/specialZone/YzxZone"], resolve);
//const Personal = resolve => require(['@/components/personal/Personal'], resolve);
Vue.use(Router);

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    //vue中使用vue-router切换页面时滚动条自动滚动到顶部
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: "/", // 首页
      name: "Index",
      component: Index,
      meta: { isAllowNoLogin: true,nameCN:"首页" }
    },
    {
      path: "/Login", // 登录
      name: "Login",
      component: Login,
      meta: { isAllowNoLogin: true, nameCN:"登录注册" }
    },
    {
      path: "/wx_login_notice", // 微信登录回调
      name: "wx_login_notice",
      component: () => import("@/components/wx_login_notice.vue"),
      meta: { isAllowNoLogin: true, nameCN:"微信回调" }
    },
    {
      path: "/ForgetPassword", // 忘记密码
      name: "ForgetPassword",
      component: ForgetPassword,
      meta: { isAllowNoLogin: true, nameCN:"忘记密码" }
    },
    {
      path: "/SignUp", // 注册
      component: SignUp,
      meta: { isAllowNoLogin: true, nameCN:"登录注册" },
      children: [
        {
          path: "/",
          name: "SignUp",
          component: CheckPhone,
          meta: { isAllowNoLogin: true }
        },
        {
          path: "checkPhone",
          name: "CheckPhone",
          component: CheckPhone,
          meta: { isAllowNoLogin: true }
        },
        {
          path: "inputInfo",
          name: "InputInfo",
          component: InputInfo,
          meta: { isAllowNoLogin: true }
        },
        {
          path: "signUpDone",
          name: "SignUpDone",
          component: SignUpDone,
          meta: { isAllowNoLogin: true }
        }
      ]
    },
    {
      path: "/ShopCart", // 购物车结算
      meta:{nameCN:"购物车"},
      component: ShopCart,
      children: [
        {
          path: "/",
          name: "ShopCart",
          component: MyCart
        },
        {
          path: "MyCart",
          name: "MyCart",
          component: MyCart
        },
        {
          path: "CheckOder",
          name: "CheckOder",
          component: CheckOder
        },
        {
          path: "PayOder",
          name: "PayOder",
          component: PayOder
        },
        {
          path: "CompletePay",
          name: "CompletePay",
          component: CompletePay
        }
      ]
    },
    {
      path: '/survey/list',
      name: 'SurveyList',
      component: () => import('@/components/survey/SurveyList.vue')
    },
    {
      path: '/survey/detail/:id',
      name: 'SurveyDetail',
      component: () => import('@/components/survey/SurveyDetail.vue')
    },
    {
      path: '/survey/success',
      name: 'SurveySuccess',
      component: () => import('@/components/survey/SurveySuccess.vue')
    },
    {
      path: '/personalizedRecommendations',
      name: 'SurveySuccess',
      component: () => import('@/components/personalizedRecommendations.vue')
    },
    {
      path: "/DeleteCart", // 删除购物车商品
      meta:{nameCN:"删除购物车商品"},
      name: "DeleteCart",
      component: DeleteCart
    },
    {
      path: "/GoodsList", // 商品列表
      meta:{nameCN:"商品列表"},
      name: "GoodsList",
      component: GoodsList
      /* meta:{requireAuth},*/
    },
    {
      path: "/NoLogin", // 未登录弹出框
      name: "NoLogin",
      component: NoLogin
    },
    {
      path: "/IndexPopup", // 首页弹出框
      name: "IndexPopup",
      component: IndexPopup
    },
    {
      path: "/Collect", // 收藏弹出框
      name: "Collect",
      component: Collect
    },
    {
      path: "/NoCollect", // 取消收藏弹出框
      name: "NoCollect",
      component: NoCollect
    },
    {
      path: "/ListClassify", // 列表药理分类
      meta:{nameCN:"列表药理分类"},
      name: "ListClassify",
      component: ListClassify
    },
    {
      path: "/RightFlex", // 右侧悬浮框
      name: "RightFlex",
      component: RightFlex
    },
    {
      path: "/BackTop", // 返回顶部按钮
      name: "BackTop",
      component: BackTop
    },
    {
      path: "/goodsDetail", // 商品详情
      meta:{nameCN:"商品详情"},
      name: "GoodsDetail",
      component: GoodsDetail
    },
    {
      path: "/GoodsDetailPreview", // 商品详情预览页
      meta:{nameCN:"商品详情预览页"},
      name: "GoodsDetailPreview",
      component: GoodsDetailPreview
    },
    {
      path: "/shoppingCart", // 商品详情
      meta:{nameCN:"商品详情"},
      name: "ShoppingCart",
      component: ShoppingCart
    },
    {
      path: "/confirmOrder", // 订单页面
      meta:{nameCN:"确认订单"},
      name: "confirmOrder",
      component: () => import("@/components/cart/confirmOrder.vue")
    },
    {
      path: "/payStatus", // 订单页面
      meta:{nameCN:"订单-支付"},
      name: "payStatus",
      component: () => import("@/components/cart/payStatus.vue")
    },
    {
      path: "/order", // 订单页面
      meta:{nameCN:"订单页面"},
      name: "Order",
      component: Order
    },
    {
      path: "/pay", // 支付页面
      meta:{nameCN:"订单-支付"},
      name: "Pay",
      component: Pay
    },
    {
      path: "/payDone", // 支付成功页面
      name: "PayDone",
      component: PayDone
    },
    {
      path: "/freeback", // 反馈页面
      meta:{nameCN:"反馈页面"},
      name: "Freeback",
      component: Freeback
    },
    {
      path: "/home", // 主页
      meta:{nameCN:"主页"},
      component: Home,
      children: [
        {
          path: "/",
          name: "HomeIndex",
          component: MyOrder
        },
        {
          path: "myAddress",
          name: "MyAddress",
          component: MyAddress
        },
        {
          path: "addAddress",
          name: "AddAddress",
          component: AddAddress
        },
        {
          path: "myOrder",
          name: "HomeMyOrder",
          component: MyOrder
        },
        {
          path: "myShoppingCart",
          name: "MyShoppingCart",
          component: MyShoppingCart
        }
      ]
    },
    {
      path: "/merchant",
      name: "Merchant",
      component: Merchant
    },
    {
      path: "/personal", // 个人中心首页
      meta:{nameCN:"个人中心"},
      name: "/personal",
      component: () => import("@/components/personal/Personal.vue"),

      children: [
        {
          path: "MyQua", //我的资质
          meta:{nameCN:"我的资质"},
          name: "MyQua",
          component: () => import("@/components/personal/MyQua.vue")
        },
        {
          path: "Site", //收货地址
          meta:{nameCN:"收货地址"},
          name: "Site",
          component: () => import("@/components/personal/Site.vue")
        },
        // {
        //   path: "EnterpriseQua", //企业资质
        //   meta:{nameCN:"企业资质"},
        //   name: "EnterpriseQua",
        //   component: () => import("@/components/personal/EnterpriseQua.vue")
        // },
        {
          path: "CreditInfo", //收货地址
          meta:{nameCN:"账期详情"},
          name: "CreditInfo",
          component: () => import("@/components/personal/CreditInfo.vue")
        },
        {
          path: "Coupon", //优惠劵
          name: "Coupon",
          meta: {
            title: "优惠券管理",
            nameCN:"优惠劵"
          },
          component: () => import("@/components/personal/Coupon.vue")
        },
        {
          path: "Balance", //余额管理
          name: "Balance",
          meta:{nameCN:"余额管理"},
          component: () => import("@/components/personal/Balance.vue")
        },
        {
          path: "/Withdraw", //余额管理去提现
          meta:{nameCN:"余额管理去提现"},
          name: "Withdraw",
          component: () => import("@/components/personal/Withdraw.vue")
        },
        {
          path: "Rightpersonal", //个人中心
          meta:{nameCN:"个人中心"},
          name: "Rightpersonal",
          component: () => import("@/components/personal/Rightpersonal.vue")
        },
        {
          path: "Basic", //基本信息
          meta:{nameCN:"基本信息"},
          name: "Basic",
          component: () => import("@/components/personal/Basic.vue")
        },
        {
          path: "Favorites", //我的收藏
          meta:{nameCN:"我的收藏"},
          name: "Favorites",
          component: () => import("@/components/personal/Favorites.vue")
        },
        {
          path: "Purchase", //智能采购
          meta:{nameCN:"智能采购"},
          name: "Purchase",
          component: () => import("@/components/personal/Purchase.vue")
        },
        {
          path: "Member", //多会员管理
          meta:{nameCN:"多会员管理"},
          name: "Member",
          component: () => import("@/components/personal/Member.vue")
        },
        {
          path: "/Unbound", //多会员管理-未绑定手机号
          meta:{nameCN:"多会员管理-未绑定手机号"},
          name: "Unbound",
          component: () => import("@/components/personal/Unbound.vue")
        },
        {
          path: "MyMessages", //我的消息
          meta:{nameCN:"我的消息"},
          name: "MyMessages",
          component: () => import("@/components/personal/MyMessages.vue")
        },
        {
          path: "MyRequest", //我的求购
          meta:{nameCN:"我的求购"},
          name: "MyRequest",
          component: () => import("@/components/personal/MyRequest.vue")
        },

        {
          path: "MyFeedback", //我的反馈
          meta:{nameCN:"我的反馈"},
          name: "MyFeedback",
          component: () => import("@/components/personal/MyFeedback.vue")
        },

        {
          path: "MyOrder", //我的订单
          meta:{nameCN:"我的订单"},
          name: "MyOrder",
          component: () => import("@/components/personal/MyOrder.vue")
        },
        {
          path: "MyCouponOrder", //我的订单
          meta:{nameCN:"我的订单"},
          name: "MyCouponOrder",
          component: () => import("@/components/personal/MyCouponOrder.vue")
        },
        {
          path: "Zsm", //我的订单
          meta:{nameCN:"追溯码下载"},
          name: "Zsm",
          component: () => import("@/components/personal/Zsm.vue")
        },
        {
          path: "Report", //我的订单
          meta:{nameCN:"检测报告查阅"},
          name: "Report",
          component: () => import("@/components/personal/Report.vue")
        },
        {
          path: "/OrderDetails", //订单详情
          meta:{nameCN:"订单详情"},
          name: "OrderDetails",
          component: () => import("@/components/personal/OrderDetails.vue")
        },
        {
          path: "UserFeedback", //用户反馈
          meta:{nameCN:"用户反馈"},
          name: "UserFeedback",
          component: () => import("@/components/personal/UserFeedback.vue")
        },
        {
          path: "Details", //用户反馈
          meta:{nameCN:"用户反馈"},
          name: "Details",
          component: () => import("@/components/personal/Details.vue")
        }
      ]
    },
    {
      path: "/BuyingArea", //求购专区
      meta:{nameCN:"专区"},
      name: "BuyingArea",
      component: () => import("@/components/personal/BuyingArea.vue")
    },
    {
      path: "/PointsMall", //积分商城
      meta:{nameCN:"积分商城"},
      name: "PointsMall",
      component: () => import("@/components/pointsmall/PointsMall.vue")
    },
    {
      path: "/Sign", //签到
      meta:{nameCN:"签到"},
      name: "Sign",
      component: () => import("@/components/pointsmall/Sign.vue")
    },
    {
      path: "/PointsIndividual", //积分商城个人中心
      meta:{nameCN:"积分商城个人中心"},
      name: "PointsIndividual",
      component: () => import("@/components/pointsmall/PointsIndividual.vue"),
      children: [
        {
          path: "MyScores", //我的积分
          meta:{nameCN:"我的积分"},
          name: "MyScores",
          component: () => import("@/components/pointsmall/MyScores.vue")
        },
        {
          path: "PointsOrder", //积分订单
          meta:{nameCN:"积分订单"},
          name: "PointsOrder",
          component: () => import("@/components/pointsmall/PointsOrder.vue")
        },
        {
          path: "Address", //我的地址
          meta:{nameCN:"我的地址"},
          name: "Address",
          component: () => import("@/components/pointsmall/Address.vue")
        },

      ]
    },
    {
      path: "/Lottery", //抽奖页面
      meta:{nameCN:"抽奖页面"},
      name: "Lottery",
      component: () => import("@/components/lottery/Lottery.vue")
    },
    {
      path: "/preempt", //抽奖页面
      meta:{nameCN:"占山头"},
      name: "preempt",
      component: () => import("@/components/preempt/index.vue")
    },
    {
      path: "/preemptDetails", //促销专区页面
      meta:{nameCN:"占山头商品详情"},
      name: "preemptDetails",
      component: () => import("@/components/preempt/details.vue")
    },
    {
      path: "/myPreempt", //促销专区页面
      meta:{nameCN:"我的山头"},
      name: "myPreempt",
      component: () => import("@/components/preempt/myPreempt.vue")
    },
    {
      path: "/ShoppingCartPage", //购物车页面
      meta:{nameCN:"购物车页面"},
      name: "ShoppingCartPage",
      component: () => import("@/components/pointsmall/ShoppingCartPage.vue")
    },
    {
      path: "/ProductDetails", //积分商品详情
      meta:{nameCN:"积分商品详情"},
      name: "ProductDetails",
      component: () => import("@/components/pointsmall/ProductDetails.vue")
    },
    {
      path: "/IntegralSettlement", //积分结算页面
      meta:{nameCN:"积分结算页面"},
      name: "IntegralSettlement",
      component: () => import("@/components/pointsmall/IntegralSettlement.vue")
    },
    {
      path: "/ChineseMedicineZone", // 中药专区页面
      meta:{nameCN:"专区"},
      name: "ChineseMedicineZone",
      component: ChineseMedicineZone
    },
    {
      path: "/ClinicZone", // 诊所专区页面
      meta:{nameCN:"专区"},
      name: "ClinicZone",
      component: ClinicZone
    },

    {
      path: "/qxzq", // 器械专区页面333
      meta:{nameCN:"专区"},
      name: "Qxzq",
      component: Qxzq
    },
    {
      path: "/ApparatusZone", // 器械专区页面
      meta:{nameCN:"专区"},
      name: "ApparatusZone",
      component: ApparatusZone
    },
    {
      path: "/DailyZone", // 日化专区页面
      meta:{nameCN:"专区"},
      name: "DailyZone",
      component: DailyZone
    },
    {
      path: "/newGoods", // 新品优选
      meta:{nameCN:"新品优选"},
      name: "newGoods",
      component: NewGoods
    },
    {
      path: "/sigMail", // 单品包邮页面
      meta:{nameCN:"单品包邮"},
      name: "sigMail",
      component: SigMail
    },
    {
      path: "/ClearZoom", // 清仓专区页面
      meta:{nameCN:"专区"},
      name: "ClearZoom",
      component: ClearZoom
    },
    {
      path: "/SpecialZone", // 特供专区页面
      meta:{nameCN:"专区"},
      name: "SpecialZone",
      component: SpecialZone
    },
    // {
    //   path: "/YzxZone", // 医知学页面
    //   meta:{nameCN:"医知学"},
    //   name: "YzxZone",
    //   component: YzxZone
    // },
    {
      path: "/ComPackageZone", // 组合套餐专区页面
      meta:{nameCN:"专区"},
      name: "ComPackageZone",
      component: ComPackageZone
    },
    {
      path: "/FreeZone", // 单品包邮专区页面
      meta:{nameCN:"专区"},
      name: "FreeZone",
      component: FreeZone
    },
    {
      path: "/BrandZone", // 品牌专区页面
      meta:{nameCN:"专区"},
      name: "BrandZone",
      component: BrandZone
    },
    {
      path: "/BrandList", // 品牌单独列表页面
      meta:{nameCN:"专区"},
      name: "BrandList",
      component: BrandList
    },
    {
      path: "/PublicZone", // banner+列表模式专区页面
      meta:{nameCN:"专区"},
      name: "PublicZone",
      component: PublicZone
    },
    {
      path: "/NewDrug", // 新特药
      meta:{nameCN:"新特药"},
      name: "NewDrug",
      component: NewDrug
    },

    {
      path: "/Promotion", //促销专区页面
      meta:{nameCN:"专区"},
      name: "Promotion",
      component: () => import("@/components/specialZone/Promotion.vue")
    },
    {
      path: "/WeeklyList", //促销专区-每周特价列表
      meta:{nameCN:"专区"},
      name: "WeeklyList",
      component: () => import("@/components/specialZone/WeeklyList.vue")
    },
    {
      path: "/BoutiqueList", //促销专区-买赠列表
      meta:{nameCN:"专区"},
      name: "BoutiqueList",
      component: () => import("@/components/specialZone/BoutiqueList.vue")
    },
    {
      path: "/SwapList", //促销专区-换购列表
      meta:{nameCN:"专区"},
      name: "SwapList",
      component: () => import("@/components/specialZone/SwapList.vue")
    },

    {
      path: "/Seckill", //秒杀专区页面
      meta:{nameCN:"专区"},
      name: "Seckill",
      component: () => import("@/components/specialZone/Seckill.vue")
    },
    {
      path: "/NewCoupons", // 新人优惠券专区页面
      meta:{nameCN:"专区"},
      name: "NewCoupons",
      component: NewCoupons
    },
    {
      path: "/NewSpecialOffer", // 新人特价专区页面
      meta:{nameCN:"专区"},
      name: "NewSpecialOffer",
      component: NewSpecialOffer
    },
    {
      path: "/Receive", //领券中心
      meta:{nameCN:"专区"},
      name: "Receive",
      component: () => import("@/components/specialZone/Receive.vue"),
    },
    {
      path: "/couponPayOder",
      meta:{nameCN:"优惠券订单结算"},
      name: "CouponPayOder",
      component: ()=>import("@/components/coupon/CouponPayOder.vue")
    },
    {
      path: "/couponCompletePay",
      meta:{nameCN:"优惠券订单完成支付"},
      name: "CouponCompletePay",
      component: ()=>import("@/components/coupon/CouponCompletePay.vue")
    },
    // {
    //   path: "/mainVenue",
    //   meta:{nameCN:"主会场"},
    //   name: "MainVenue",
    //   component: ()=>import("@/components/mainVenue.vue")
    // },
    {
      path: "/GoodsCombo", //商品套餐
      meta:{nameCN:"商品套餐"},
      name: "GoodsCombo",
      component: () => import("@/components/GoodsCombo.vue")
    },
    {
      path: "/EmptyPage", //搜索为空专区页面
      meta:{nameCN:"专区"},
      name: "EmptyPage",
      component: EmptyPage
    },
    {
      path: "/Helps", //帮助中心
      meta:{nameCN:"帮助中心"},
      name: "helpss",
      component: () => import("@/components/helpss/Helps.vue"),
      children: [
        {
          path: "HelpLogin", //免费注册
          meta:{nameCN:"免费注册"},
          name: "HelpLogin",
          component: () => import("@/components/helpss/HelpLogin.vue")
        },
      ]
    },
    {
      path: "/News", //新闻中心页面
      meta:{nameCN:"新闻中心页面"},
      name: "News",
      component: () => import("@/components/News/News.vue"),
      children:[
        {
          path: "NewsList", //新闻列表
          meta:{nameCN:"新闻列表"},
          name: "NewsList",
          component: () => import("@/components/News/NewsList.vue")
        },
        {
          path: "NewsDetails", //新闻详情
          meta:{nameCN:"新闻详情"},
          name: "NewsDetails",
          component: () => import("@/components/News/NewsDetails.vue")
        }
      ]
    },
    {
      path: "/combination", //组合购
      meta:{nameCN:"抽奖页面"},
      name: "combination",
      component: () => import("@/components/combination/index.vue")
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js